import api from "../../../../../api";

export const requestGetPartOffer = (id) => api.get(`/partoffer/${id}`);
